module.exports = __webpack_public_path__ + "img/VoluntariadoHacienda.e7f5186b.png";